import { Alert, Button, Group, Text, type MantineSpacing } from '@mantine/core';
import { IconClockExclamation, IconLogin2 } from '@tabler/icons-react';
import { useAttendance } from '../../hooks/useAttendance';
import { clockInHint, type ClockInHintContext } from '../../lib/attendance';

/**
 * Hinweis beim Zeit buchen bzw. Bericht anlegen, wenn man nicht eingestempelt ist (v1.405.0, Vorgabe
 * Kevin: Hinweis mit Knopf, keine Sperre, nichts automatisch). Pause zählt als eingestempelt.
 */
export function ClockInHint({ context, mt, mb }: { context: ClockInHintContext; mt?: MantineSpacing; mb?: MantineSpacing }) {
  const { status, punch, punching } = useAttendance();
  const text = clockInHint(status?.state, context);
  if (!text) return null;
  return (
    <Alert color="yellow" variant="light" icon={<IconClockExclamation size={16} />} p="xs" mt={mt} mb={mb}>
      <Group justify="space-between" gap="xs" wrap="wrap">
        <Text size="sm">{text}</Text>
        <Button
          size="xs"
          color="green"
          leftSection={<IconLogin2 size={14} />}
          loading={punching === 'IN'}
          onClick={() => punch('IN')}
        >
          Jetzt einstempeln
        </Button>
      </Group>
    </Alert>
  );
}
